import React, { useMemo } from 'react';
import { bool, object, oneOf } from 'prop-types';
import classNames from 'classnames/bind';
import { Text } from '@s7/ui-kit';
import styles from './PasswordStrengthTip.css';
var cx = classNames.bind(styles);
var variants = ['default', 'dimmed'];

var PasswordStrengthTip = function PasswordStrengthTip(_ref) {
  var variant = _ref.variant,
      error = _ref.error,
      dictionary = _ref.dictionary;
  var styleToggles = {
    error: error,
    variantDefault: variant === variants[0],
    variantDimmed: variant === variants[1]
  };
  var requirements = useMemo(function () {
    return [{
      key: 'com.password.strength.requirement.0',
      text: dictionary.t('com.password.strength.requirement.0')
    }, {
      key: 'com.password.strength.requirement.1',
      text: dictionary.t('com.password.strength.requirement.1')
    }, {
      key: 'com.password.strength.requirement.2',
      text: dictionary.t('com.password.strength.requirement.2')
    }];
  }, [dictionary]);
  var requirementsList = requirements.map(function (requirement) {
    return /*#__PURE__*/React.createElement(Text, {
      as: "li",
      classes: {
        root: cx('requirement', styleToggles)
      },
      key: requirement.key
    }, requirement.text);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    as: "div",
    classes: {
      root: cx('title', styleToggles)
    },
    size: 16,
    weight: "semibold"
  }, dictionary.t('com.password.strength.title')), /*#__PURE__*/React.createElement("div", {
    className: cx('list', styleToggles)
  }, /*#__PURE__*/React.createElement("ul", null, requirementsList)));
};

PasswordStrengthTip.propTypes = {
  error: bool,
  variant: oneOf(variants),
  dictionary: object
};
PasswordStrengthTip.defaultProps = {
  error: false,
  variant: variants[0],
  dictionary: {
    t: function t() {
      return Function;
    }
  }
};
export default PasswordStrengthTip;